import React from "react";
import Header from "@/components/site/Header";
import PalmettoHero from "@/components/site/PalmettoHero";
import ChantiersShowcase from "@/components/site/ChantiersShowcase";
import SolutionsGrid from "@/components/site/SolutionsGrid";
import TakenCareOf from "@/components/site/TakenCareOf";
import PartnerSection from "@/components/site/PartnerSection";
import GoalsQuiz from "@/components/site/GoalsQuiz";
import FinalCTA from "@/components/site/FinalCTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="relative bg-[#fdfbf7]" data-testid="home-page">
      <Header />
      <main>
        <PalmettoHero />
        <ChantiersShowcase />
        <SolutionsGrid />
        <TakenCareOf />
        <PartnerSection />
        <GoalsQuiz />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <div className="grain-overlay" aria-hidden="true" />
    </div>
  );
}
